import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap-v5";
import AutoResizeTextArea from '../components/AutoResizeTextArea';

export default function PreQualify() {
  const { id, name } = useParams();
  const navigate = useNavigate();
  
  const [preQualifyData, setPreQualifyData] = useState({
    
    how_did_find_matchmaking_service: "",
    motivation_register_today: "",
    current_marital_status: "",
    why_start_relationship_now: "", 
    relationship_challenges_overcome: "",
    how_was_previous_dating_experience: "", 
    how_long_in_this_line: "", 
    any_children: "", 
    preferred_min_age_range: "",
    preferred_max_age_range: "", 
    meet_people_from_other_ethnic_religious	: "",
    outcome: "",
  });

  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    var token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    loadPreQualifyData(headers);
  }, []);

  const loadPreQualifyData = (headers) => {
    setStatus("loading...");
    setError("");
    
    const url = `${process.env.REACT_APP_API_URL}/getprequalify/${id}`;
    
    console.log("url: " , url);

    axios.get(url, { headers })
      .then((res) => {
        console.log("res" , res.data);
        setPreQualifyData(res.data);
        setStatus("loaded");
        setError("");
      })
      .catch((err) => {
        console.log(err);
        setError("error loading data");
        setStatus("");
      });
  };

  const handleSave = () => {
    var token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const url = `${process.env.REACT_APP_API_URL}/saveprequalify/${id}`;
    setStatus("saving...");
    setError("");

    axios.post(url, preQualifyData, { headers })
      .then((res) => {
        console.log(res.data);
        setStatus("saved");
        setError("");
      })
      .catch((err) => {
        console.log(err);
        setError("error saving data");
        setStatus("");
      });
  };

  return (
    <div className="container">
      <div className="row">
        

        <div className="col-md-6">
          <h5>1. How did you find out about our matchmaking service?</h5>
          <AutoResizeTextArea
            value={preQualifyData.how_did_find_matchmaking_service}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, how_did_find_matchmaking_service: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>2. What motivated you to seek matchmaking services?</h5>
          <AutoResizeTextArea
            value={preQualifyData.motivation_register_today}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, motivation_register_today: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>3. Tell me about your marital status and past relationships</h5>
          <AutoResizeTextArea
            value={preQualifyData.current_marital_status}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, current_marital_status: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>4. Why are you looking for a relationship now?</h5>
          <AutoResizeTextArea
            value={preQualifyData.why_start_relationship_now}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, why_start_relationship_now: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>5. What are the main relationship challenges that you would like to overcome?</h5>
          <AutoResizeTextArea
            value={preQualifyData.relationship_challenges_overcome}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, relationship_challenges_overcome: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>6. Have you tried online dating services? How did that work out for you?</h5>
          <AutoResizeTextArea
            value={preQualifyData.how_was_previous_dating_experience}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, how_was_previous_dating_experience: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>7. How long have you been working?</h5>
          <AutoResizeTextArea
            value={preQualifyData.how_long_in_this_line}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, how_long_in_this_line: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>8. What is your age and do you have children?</h5>
          <AutoResizeTextArea
            value={preQualifyData.any_children}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, any_children: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>9. What is your minimum age requirement?</h5>
          <AutoResizeTextArea
            value={preQualifyData.preferred_min_age_range}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, preferred_min_age_range: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>10. What is your maximum age requirement?</h5>
          <AutoResizeTextArea
            value={preQualifyData.preferred_max_age_range}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, preferred_max_age_range: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>11. Are you open to other religions?</h5>
          <AutoResizeTextArea
            value={preQualifyData.meet_people_from_other_ethnic_religious	}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, meet_people_from_other_ethnic_religious	: e.target.value })
            }
          />
        </div>

        <div className="col-md-6">
          <h5>12. Outcome</h5>
          <AutoResizeTextArea
            value={preQualifyData.outcome}
            onChange={(e) =>
              setPreQualifyData({ ...preQualifyData, outcome: e.target.value })
            }
          />
        </div>

        <div className="col-md-12">
          <Button onClick={handleSave} style={{ marginTop: "20px" }}>Save</Button>
          <div className="status">{status}</div>
          <div className="error">{error}</div>
        </div>
      </div>
    </div>
  );
}
